import { Link } from "wouter";
import { Store, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

import { Footer } from "@/components/Footer";
import { useI18n } from "@/lib/i18n";

export default function OwnersSelectionPage() {
    const { t } = useI18n();

    return (
        <div className="min-h-screen flex flex-col bg-background">
            

            <main className="flex-1 flex items-center justify-center py-16">
                <div className="container mx-auto px-4 max-w-4xl">
                    <div className="text-center mb-12">
                        <h1 className="text-4xl font-bold mb-4">{t("ownersSelection.title")}</h1>
                        <p className="text-xl text-muted-foreground">
                            {t("ownersSelection.subtitle")}
                        </p>
                    </div>

                    <div className="flex justify-center">
                        <Card className="group hover:border-primary transition-all duration-300 overflow-hidden max-w-md w-full">
                            <CardContent className="p-8 flex flex-col h-full">
                                <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                                    <Store className="h-8 w-8 text-primary" />
                                </div>
                                <h2 className="text-2xl font-bold mb-3">{t("ownersSelection.cardTitle")}</h2>
                                <p className="text-muted-foreground mb-8 flex-1">
                                    {t("ownersSelection.cardDesc")}
                                </p>
                                <Link href="/owners/kringloop">
                                    <Button className="w-full" size="lg">
                                        {t("ownersSelection.cta")}
                                        <ArrowRight className="h-4 w-4 ml-2" />
                                    </Button>
                                </Link>
                            </CardContent>
                        </Card>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
}
